import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Input, Select, Popconfirm, Icon, Alert } from 'antd'
import CKEditor from '@ckeditor/ckeditor5-react'
import CKEditorInline from '@ckeditor/ckeditor5-build-inline'
import TagsCard from '@components/TagsCard'
import { errors } from '@texts/errors'

@inject((store: any) => {
    const { popupStore, collectionsStore, categoriesStore, servicefieldsStore, collectionTypesStore } = store
    return { popupStore, collectionsStore, categoriesStore, servicefieldsStore, collectionTypesStore }
})
@observer
export default class EditCollectionPopup extends Component<any, any> {
    state: any = {
        errors: {},
        disable: false
    }

    handleToggleEditing = () => {
        this.setState(prevState => ({ disable: !prevState.disable }))
    }

    handleFieldChange = (name, value) => {
        this.props.collectionsStore.editField(name, value)
    }

    handleSubmitCollection = async () => {
        const { collectionsStore, popupStore } = this.props
        if (popupStore.popupType === 'editCollection') {
            await collectionsStore.updateCollection()
        } else if (popupStore.popupType === 'addCollection') {
            await collectionsStore.addCollection()
            if (!(Object.keys(collectionsStore.errors).length > 0)) {
                popupStore.togglePopup('editCollection')
            }
        }
    }

    handleDeleteCollection = async () => {
        await this.props.collectionsStore.deleteCollection()
        this.closePopup()
    }

    handleRemoveServicefield = async id => {
        await this.props.collectionsStore.deleteServicefield(id)
        this.props.servicefieldsStore.getServicefields()
    }

    handleAddServicefield = async servicefield => {
        await this.props.collectionsStore.addServicefield(servicefield)
        this.props.servicefieldsStore.getServicefields()
    }

    closePopup = () => {
        if (!this.props.disable) {
            this.props.collectionsStore.resetErrors()
            this.props.collectionsStore.resetCollection()
            this.props.popupStore.togglePopup(false)
        }
    }

    render() {
        const { disable } = this.state
        const { popupStore, categoriesStore, collectionsStore, servicefieldsStore, collectionTypesStore } = this.props
        const { collection, editCollection, types, loading, errors } = this.props.collectionsStore
        const footerButtons = (
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <div>
                    <Button disabled={loading || disable} onClick={this.closePopup}>
                        סגור
                    </Button>
                    <Button type="primary" disabled={loading || disable} onClick={() => this.handleSubmitCollection()}>
                        {loading ? <Icon type="loading" /> : ''}
                        {popupStore.popupType === 'editCollection' ? 'שמור שינויים' : 'הוסף זכות'}
                    </Button>
                </div>
                {popupStore.popupType === 'editCollection' && collection.source_id === 'LOCAL' && (
                    <Popconfirm
                        title="האם ברצונך למחוק זכות זו?"
                        onConfirm={() => this.handleDeleteCollection()}
                        okText="כן"
                        cancelText="לא"
                    >
                        <Button>מחק זכות</Button>
                    </Popconfirm>
                )}
            </div>
        )
        return (
            <Modal
                title={
                    popupStore.popupType === 'editCollection'
                        ? `עריכת ${collection.name} (מזהה: ${collection.id})`
                        : 'הוספת זכות חדשה'
                }
                visible={popupStore.popupType === 'editCollection' || popupStore.popupType === 'addCollection'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                closable={!disable}
                maskClosable={!disable}
                footer={footerButtons}
            >
                {'serverError' in errors && (
                    <Alert style={{ marginBottom: '1rem' }} type="error" message={errors.serverError} />
                )}
                <label>
                    <strong>שם הזכות</strong>
                </label>
                <Input
                    placeholder="הזן את שם הזכות"
                    onChange={e => this.handleFieldChange('name', e.target.value)}
                    disabled={popupStore.popupType === 'editCollection' && collection.source_id !== 'LOCAL'}
                    value={editCollection.name}
                />
                {'nameError' in errors && (
                    <Alert style={{ marginBottom: '1rem' }} type="error" message={errors.nameError} />
                )}
                <label>
                    <strong>תיאור הזכות</strong>
                </label>
                {/* <Input.TextArea
                    disabled={disable}
                    autosize={{ minRows: 2, maxRows: 6 }}
                    style={{ marginBottom: '0.5rem' }}
                    value={editCollection.description}
                    placeholder="ללא תיאור"
                    onChange={e => this.handleFieldChange('description', e.target.value)}
                /> */}
                <div style={{ border: '1px solid #dadada', borderRadius: '5px' }}>
                    <CKEditor
                        data={editCollection.description ? editCollection.description : ''}
                        editor={CKEditorInline}
                        disabled={disable}
                        onChange={(event, editor) => {
                            const data = editor.getData()
                            this.handleFieldChange('description', data)
                        }}
                        config={{
                            language: 'he',
                            toolbar: [
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'blockQuote',
                                'insertTable',
                                'undo',
                                'redo'
                            ]
                        }}
                    />
                </div>
                {popupStore.popupType === 'editCollection' && (
                    <Fragment>
                        <label>
                            <strong>סוג הזכות</strong>
                        </label>
                        <Select
                            disabled={disable}
                            value={editCollection.collection_type_id ? editCollection.collection_type_id : undefined}
                            style={{ width: '100%', marginBottom: '1.5rem' }}
                            onChange={e => this.handleFieldChange('collection_type_id', e)}
                            placeholder="ללא סוג זכות"
                        >
                            {collectionTypesStore.list.map((type, index) => {
                                if (type.name)
                                    return (
                                        <Select.Option key={index} value={type.id}>
                                            {type.name}
                                        </Select.Option>
                                    )
                            })}
                        </Select>
                        <TagsCard
                            tagsList={collection.categories}
                            selectList={categoriesStore.list}
                            onSubmit={tag => collectionsStore.addCategory(tag)}
                            onRemove={tag => collectionsStore.deleteCategory(tag.id)}
                            singularName="קטגוריה"
                            pluralName="קטגוריות"
                            tagName="name"
                            disableEditButtons={disable}
                            toggleEditing={() => this.handleToggleEditing()}
                            disableEdit={!!collection.id}
                            loading={loading}
                        />
                        <TagsCard
                            tagsList={collection.servicefields}
                            selectList={servicefieldsStore.list}
                            onSubmit={tag => this.handleAddServicefield(tag)}
                            onRemove={tag => this.handleRemoveServicefield(tag.id)}
                            tagName="name"
                            disableEditButtons={disable}
                            toggleEditing={() => this.handleToggleEditing()}
                            loading={loading}
                            singularName="תחום שירות"
                            pluralName="תחומי שירות"
                        />
                    </Fragment>
                )}
            </Modal>
        )
    }
}
